import { gql } from "@apollo/client";

import calibrationNodeFragment from "./calibration-node-fragment";

export default gql`
  ${calibrationNodeFragment}
  query getAssessmentAnswerCalibrations(
    $complianceProgramId: Int!
    $templateId: Int!
    $targetId: Int!
  ) {
    assessmentCalibrations(
      complianceProgramId: $complianceProgramId
      templateId: $templateId
      targetId: $targetId
    ) {
      edges {
        node {
          ...CalibrationNode
        }
      }
    }
  }
`;
